import React from 'react';
import classNames from 'classnames';

interface TabProps {
  label: string;
  icon?: React.ReactNode;
  isActive?: boolean;
  tabIndex?: number;
  disabled?: boolean;
  tabColor?: string;
  textColor?: string;
  className?: string;
  onClick?: (tabIndex: number, tabLabel: string, tabCode?: string) => void;
  code?: string;
  children?: React.ReactNode;
}

export const Tab: React.FC<TabProps> = ({
  label,
  icon,
  isActive,
  tabIndex,
  disabled,
  tabColor,
  textColor,
  className,
  onClick,
  code,
}) => {
  const handleClick = () => {
    if (disabled) return;
    onClick?.(tabIndex as number, label, code);
  };

  return (
    <a
      onClick={handleClick}
      className={classNames({ active: isActive, disabled, icon }, className)}
    >
      {icon && icon}
      {label}
      <style jsx>{`
        a {
          color: ${textColor};
          display: block;
          margin-bottom: -1px;
          user-select: none;
          padding-bottom: 6px;
        }
        a.active:not(.disabled) {
          color: ${tabColor};
          border-bottom: 1px solid ${tabColor};
        }
        a.disabled {
          color: #555;
          cursor: default;
        }
        a.icon {
          display: flex;
          align-items: center;
        }
      `}</style>
    </a>
  );
};
